import { WebsiteSliderTypeEnum } from '@onArte/shared/database/enums';
import { AbstractSliderDTO, AttachmentInterface, SliderButtonSettingsInterface } from '@onArte/shared/interfaces/common';

export class SliderDTO extends AbstractSliderDTO {
  constructor(
    id: number,
    type: WebsiteSliderTypeEnum,
    image: AttachmentInterface,
    header: string,
    buttonSettings: SliderButtonSettingsInterface | null,
    secondButtonSettings: SliderButtonSettingsInterface | null,
    description: string | null,
    public linkedItemId: string | null,
  ) {
    super(id, type, image, header, buttonSettings, secondButtonSettings, description);
  }
}
